import { countriesToRegion } from '@/lists/countriesToRegion';
import { useMemo } from 'react';
import { useQueryKindeProperties } from './query/useQueryKindeProperties';
import { useQueryUser } from './query/useQueryUser';

/**
 * Checks if user country is the same as kinde region or waiting until user country is updated
 * to make sure we load the correct product prices for the region the user is in
 * @returns {boolean} Whether the user's region matches the Kinde region
 */

type ReturnType =
  | {
      userRegionSameAsKindeRegion: false;
      isPendingUserRegionSameAsKindeRegion: true;
    }
  | {
      userRegionSameAsKindeRegion: boolean;
      isPendingUserRegionSameAsKindeRegion: false;
    };

export function useIsUserRegionSameAsKindeRegion(): ReturnType {
  const { data: kindeProperties, isPending: isPendingKindeProperties } =
    useQueryKindeProperties();
  const { data: user, isPending: isPendingUser } = useQueryUser((data) => ({
    country: data?.country,
  }));

  const kindeRegion = kindeProperties?.region;
  const userRegionSameAsKindeRegion =
    user?.country && kindeRegion
      ? countriesToRegion[user?.country] === kindeRegion
      : false;

  return useMemo(() => {
    if (isPendingUser || isPendingKindeProperties) {
      return {
        userRegionSameAsKindeRegion: false,
        isPendingUserRegionSameAsKindeRegion: true,
      };
    }
    return { userRegionSameAsKindeRegion, isPendingUserRegionSameAsKindeRegion: false };
  }, [userRegionSameAsKindeRegion, isPendingUser, isPendingKindeProperties]);
}
